import { render } from "./AppLoader.vue?vue&type=template&id=52c8423a"
import script from "./AppLoader.vue?vue&type=script&lang=js"
export * from "./AppLoader.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\chmonya\\Desktop\\Обучалки\\vue.js\\15-crm\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__